import axios from "axios";

const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API_URL
});


const cleanToken = (value) => {

    if (
        !value ||
        typeof value !== "string"
    ) {
        return null;
    }

    let token = value.trim();

    if (
        token
            .toLowerCase()
            .startsWith("bearer ")
    ) {
        token =
            token.slice(7).trim();
    }

    return token || null;
};


const getUserObject = () => {

    try {

        return JSON.parse(
            localStorage.getItem("user") ||
            "null"
        );

    } catch (error) {

        return null;
    }
};


const getUserToken = () => {

    let token =
        cleanToken(
            localStorage.getItem(
                "user_token"
            )
        );

    if (token) {
        return token;
    }


    const user =
        getUserObject();

    token =
        cleanToken(
            user?.token ||
            user?.accessToken
        );


    if (token) {

        localStorage.setItem(
            "user_token",
            token
        );

        return token;
    }


    return null;
};


const getAdminToken = () => {

    let token =
        cleanToken(
            localStorage.getItem(
                "admin_token"
            )
        );

    if (token) {
        return token;
    }


    /*
     * Ho tro phien admin cu:
     * neu admin_token chua ton tai,
     * thu token cu mot lan.
     */
    token =
        cleanToken(
            localStorage.getItem(
                "token"
            )
        );


    if (token) {

        localStorage.setItem(
            "admin_token",
            token
        );

        return token;
    }


    return null;
};


const isAdminPage = () => {

    const path =
        window.location.pathname ||
        "";

    return (
        path === "/admin" ||
        path.startsWith("/admin/")
    );
};


axiosInstance.interceptors.request.use(
    (config) => {

        const token =
            isAdminPage()
                ? getAdminToken()
                : getUserToken();


        if (token) {

            config.headers =
                config.headers || {};

            config.headers.Authorization =
                `Bearer ${token}`;
        }


        return config;
    },

    (error) =>
        Promise.reject(error)
);


export default axiosInstance;
